export default __webpack_public_path__ + "static/media/SonoffEnv.d0da6c79.jpeg";